import './primalalchemy/style';
import FormStructure from './primalalchemy/form_structure';

export default FormStructure;